import React, { useState } from 'react';
import api from '../../services/api';
import { ELEMENT_CONFIG } from '../../utils/elementConfig';

const Estimator = () => {
  const [jobName, setJobName] = useState('');
  const [elements, setElements] = useState([
    { element_category: '', element_detail: '', cubic_yards: '' }
  ]);
  const [estimate, setEstimate] = useState(null);
  const [loading, setLoading] = useState(false);

  const addElement = () => {
    setElements([...elements, { element_category: '', element_detail: '', cubic_yards: '' }]);
  };

  const updateElement = (index, field, value) => {
    const updated = [...elements];
    updated[index][field] = value;
    
    if (field === 'element_category') {
      updated[index].element_detail = '';
    }
    
    setElements(updated);
  };

  const removeElement = (index) => {
    setElements(elements.filter((_, i) => i !== index));
  };

  const calculateEstimate = async () => {
    setLoading(true);
    try {
      const response = await api.post('/analytics/estimate-job', {
        job_name: jobName,
        elements: elements.map(el => ({
          ...el,
          cubic_yards: parseFloat(el.cubic_yards)
        }))
      });
      setEstimate(response.data);
    } catch (error) {
      console.error('Error calculating estimate:', error);
      alert('Failed to calculate estimate');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="estimator">
      <div className="card">
        <h3>Job Estimator</h3>
        
        <div className="form-group">
          <label>Job Name:</label>
          <input
            type="text"
            value={jobName}
            onChange={(e) => setJobName(e.target.value)}
            placeholder="e.g., New Commercial Building"
          />
        </div>

        <h4>Elements</h4>
        {elements.map((element, index) => (
          <div key={index} className="element-row">
            <select
              value={element.element_category}
              onChange={(e) => updateElement(index, 'element_category', e.target.value)}
            >
              <option value="">Select Category</option>
              {Object.keys(ELEMENT_CONFIG).map(cat => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>

            <select
              value={element.element_detail}
              onChange={(e) => updateElement(index, 'element_detail', e.target.value)}
              disabled={!element.element_category}
            >
              <option value="">Select Detail</option>
              {element.element_category && ELEMENT_CONFIG[element.element_category].map(detail => (
                <option key={detail} value={detail}>{detail}</option>
              ))}
            </select>

            <input
              type="number"
              step="0.01"
              value={element.cubic_yards}
              onChange={(e) => updateElement(index, 'cubic_yards', e.target.value)}
              placeholder="Cubic Yards"
            />

            <button onClick={() => removeElement(index)} className="danger">Remove</button>
          </div>
        ))}

        <div style={{ display: 'flex', gap: '10px', marginTop: '15px' }}>
          <button onClick={addElement} className="secondary">Add Element</button>
          <button onClick={calculateEstimate} className="primary" disabled={loading}>
            {loading ? 'Calculating...' : 'Calculate Estimate'}
          </button>
        </div>
      </div>

      {estimate && (
        <div className="estimate-results">
          <h3>Estimate for: {estimate.job_name}</h3>
          
          {estimate.estimates.map((el, idx) => (
            <div key={idx} className="estimate-element">
              {el.error ? (
                <>
                  <h4>{el.element_detail}</h4>
                  <p style={{ color: '#e74c3c' }}>{el.error}</p>
                </>
              ) : (
                <>
                  <h4>
                    {el.element_detail}: {el.cubic_yards} CY × {el.phases?.total?.avg_mh_per_cy} MH/CY = {el.total_estimated_manhours} MH
                  </h4>
                  
                  {el.phases && (
                    <ul>
                      {el.phases.forming && (
                        <li>Forming: {el.phases.forming.calculation}</li>
                      )}
                      {el.phases.pouring && (
                        <li>Pouring: {el.phases.pouring.calculation}</li>
                      )}
                      {el.phases.stripping && (
                        <li>Stripping: {el.phases.stripping.calculation}</li>
                      )}
                      {el.phases.punch && (
                        <li>Punch Out: {el.phases.punch.calculation}</li>
                      )}
                    </ul>
                  )}
                  
                  <p className="based-on">Based on {el.based_on_logs} historical pours</p>
                </>
              )}
            </div>
          ))}

          <div className="total">
            <h3>Total: {estimate.total_estimated_manhours} manhours</h3>
          </div>
        </div>
      )}
    </div>
  );
};

export default Estimator;